import styled from 'styled-components'

const Container = styled.textarea`
  flex: 1 0;
  padding: 0.6rem;
  border: 2px solid lightgrey;
`

export default function NoteText({ editing, value, onChange, ...rest }) {
  const changeHandler = (e) => {
    if (editing) {
      onChange(e.target.value);
    }
  }

  return (
    <Container
      readonly={!editing}
      value={value}
      onChange={changeHandler}
      {...rest}
    />
  )
}
